// extracted by mini-css-extract-plugin
export default {"loadingContainer":"LoadingSpinner_loadingContainer__ZwrwV","loadingSpinner":"LoadingSpinner_loadingSpinner__PuVUO"};